import { render, staticRenderFns } from "./GalleryEditor.vue?vue&type=template&id=0cbdd7d4&scoped=true&"
import script from "./GalleryEditor.vue?vue&type=script&lang=js&"
export * from "./GalleryEditor.vue?vue&type=script&lang=js&"
import style0 from "./GalleryEditor.vue?vue&type=style&index=0&id=0cbdd7d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbdd7d4",
  null
  
)

export default component.exports